module.exports = __webpack_public_path__ + "img/submit.93e7e610.png";